export interface LocationData {
  slug: string;
  name: string;
  postalCode: string;
  distance: string;
  landmarks: string[];
}

export const HAAR_RADIUS_GEMEINDEN: LocationData[] = [
  { slug: "vaterstetten", name: "Vaterstetten", postalCode: "85591", distance: "4 km", landmarks: ["Sportpark Vaterstetten", "Baldham"] },
  { slug: "grasbrunn", name: "Grasbrunn", postalCode: "85630", distance: "5 km", landmarks: ["Sportpark Grasbrunn", "Neukeferloh"] },
  { slug: "feldkirchen", name: "Feldkirchen", postalCode: "85622", distance: "6 km", landmarks: ["Fliegerhorst Gelände", "Heimstetten"] },
  { slug: "putzbrunn", name: "Putzbrunn", postalCode: "85640", distance: "7 km", landmarks: ["Sportzentrum Putzbrunn", "Waldkolonie"] },
  { slug: "aschheim", name: "Aschheim", postalCode: "85609", distance: "8 km", landmarks: ["Sportpark Aschheim", "Dornach"] },
  { slug: "ottobrunn", name: "Ottobrunn", postalCode: "85521", distance: "9 km", landmarks: ["Phönix-Bad", "Sportpark Ottobrunn"] },
  { slug: "neubiberg", name: "Neubiberg", postalCode: "85579", distance: "8 km", landmarks: ["Umweltgarten", "Unterbiberg"] },
  { slug: "kirchheim", name: "Kirchheim bei München", postalCode: "85551", distance: "9 km", landmarks: ["Heimstettener See", "Landesgartenschau-Gelände"] },
  { slug: "hohenbrunn", name: "Hohenbrunn", postalCode: "85662", distance: "11 km", landmarks: ["Riemerling Sportbad"] },
  { slug: "poing", name: "Poing", postalCode: "85586", distance: "12 km", landmarks: ["Wildpark Poing", "Bergfeldsee"] },
  { slug: "zorneding", name: "Zorneding", postalCode: "85604", distance: "13 km", landmarks: ["Pöringer Forst"] },
  { slug: "ismaning", name: "Ismaning", postalCode: "85737", distance: "14 km", landmarks: ["Sportpark Ismaning", "Taxetweiher"] },
  { slug: "garching", name: "Garching bei München", postalCode: "85748", distance: "16 km", landmarks: ["Business Campus", "Forschungszentrum"] },
  { slug: "muenchen-ost", name: "München Ost", postalCode: "81829", distance: "8 km", landmarks: ["Riemer Park", "Messestadt Riem"] }
];
